import { translate } from '@fiverr-private/i18n-react';
import { getSubCategoryKey } from './utils';

export const getTranslatedNestedSubCategoryName = (subCategoryId: number, nestedSubCategoryId: number): string =>
    translate(`${getSubCategoryKey(subCategoryId)}.nested_sub_cat_${nestedSubCategoryId}.name`);
